/*
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-08-05 15:10:25
 * @LastEditors: knx-xc
 */
import http from '../http';
/**
 * @description:  文章列表数据
 * @params ：  
 */

export var article_list = function article_list() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/portal/article/page',
    data: data
  };
  return http(params);
};
/**
 * @description:  文章列表 -文章详情
 * @params ：  
 */

export var article_detail = function article_detail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/portal/article/detail/' + data.id,
    data: data
  };
  return http(params);
};
/**
 * @description: 贴心健康- 近期活动 
 * @params ： 
 */

export var intimate_activities = function intimate_activities() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/portal/intimatehealth/activities',
    data: data
  };
  return http(params);
};
/**
 * @description:  贴心健康- 精选主题
 * @params ： 
 */

export var intimate_selectedtopics = function intimate_selectedtopics() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/portal/intimatehealth/selectedtopics',
    data: data
  };
  return http(params);
};
/**
 * @description:  贴心健康- 类目
 * @params ： 
 */

export var intimate_topicslist = function intimate_topicslist() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/portal/intimatehealth/topicslist',
    data: data
  };
  return http(params); // return new Promise((resolve, reject) => {
  //   let data = require('../../tools/menuConfig');
  //   let res = {
  //     code : 0,
  //     msg:'success',
  //     data:data.menuList
  //   }  
  //   resolve(res)
  // })
};
/**
 * @description:  贴心健康- 类目下的商品列表
 * @params ： 
 */

export var intimate_productlist = function intimate_productlist() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/portal/intimatehealth/productlist/' + data.id,
    data: data
  };
  return http(params);
};
/**
 * @description:  贴心健康- 友情链接/合作伙伴  
 * @params ：   type  pageTypeCode
 *  pageCode
 * "INDEX", "官网首页"
 * "DYNAMIC", "动态"
 * "INTIMATE_HEALTH", "贴心健康"
 * "9HYZ", "9号云诊"
 * "ABOUT_US", "关于我们"
 */

export var friendly_link = function friendly_link() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/portal/common/getFriendlyLink',
    data: data,
    formData: true
  };
  return http(params);
};
/**
 *   渠道处理 (用户从渠道进入页面   统计)
 *   code   pageCode
 *  * "INDEX", "官网首页"
 * "DYNAMIC", "动态"
 * "INTIMATE_HEALTH", "贴心健康"
 * "9HYZ", "9号云诊"
 * "ABOUT_US", "关于我们"
 * 
 */

export var statics_channel = function statics_channel() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // console.log(data)
  var params = {
    method: 'post',
    api: '/portal/common/channel',
    data: data,
    formData: true
  };
  return http(params);
};
/**
 *  首页/动态/贴心健康/9号云诊/关于我们 页面pv  uv统计
 *   code   pageCode
 *  * "INDEX", "官网首页"
 * "DYNAMIC", "动态"
 * "INTIMATE_HEALTH", "贴心健康"
 * "9HYZ", "9号云诊"
 * "ABOUT_US", "关于我们"
 * 
 */

export var statics_pu = function statics_pu() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = {
    method: 'post',
    api: '/portal/common/pu',
    data: data,
    formData: true
  };
  return http(params);
};
/**
 *  首页/动态/贴心健康/9号云诊/关于我们 页面pv  uv统计
 *   code   pageCode
 *  * "INDEX", "官网首页"
 * "DYNAMIC", "动态"
 * "INTIMATE_HEALTH", "贴心健康"
 * "9HYZ", "9号云诊"
 * "ABOUT_US", "关于我们"
 * 
 */

export var save_customer_info = function save_customer_info() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  console.log(data);
  var params = {
    method: 'post',
    api: '/portal/common/saveCustomerInfo',
    data: data
  };
  return http(params);
};